import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="h-64 lg:h-full overflow-hidden">
            <img
              src={article.coverImage}
              alt={article.title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              title={`${article.title} - 火影同人指南`}
            />
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-xs text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full font-medium">
                {article.tags[0]}
              </span>
              <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
              {article.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3">
              {article.excerpt}
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
              <span>{article.author}</span>
              <span>·</span>
              <span>{article.publishDate}</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${article.title} - 火影同人指南`}
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-400">{article.readTime} 分钟</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
          <span>{article.author}</span>
          <span>·</span>
          <span>{article.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}